import { z } from 'zod';
import { bookingStatus, shift } from './shift.js';

/** Professional-facing practice context; all times are interpreted in the practice timezone. */
export const shiftView = shift.extend({
  locationName: z.string(),
  locationTimezone: z.string(),
  locationAddressLine1: z.string(),
  locationAddressLine2: z.string().nullable(),
  locationCity: z.string(),
  locationState: z.string(),
  locationPostalCode: z.string(),
  groupName: z.string(),
  bookingCount: z.number().int().nonnegative(),
  myBookingStatus: bookingStatus.nullable(),
  distanceMiles: z.number().nonnegative().nullable(),
  /** Quote from scheduled duration minus the posted unpaid break, never approved/paid earnings. */
  estimatedGrossCents: z.number().int().nonnegative().nullable(),
});
export type ShiftView = z.infer<typeof shiftView>;

/** The server owns these decisions; the client displays the reason and its next action. */
export const shiftEligibilityCode = z.enum([
  'professional_required',
  'inactive',
  'profile_incomplete',
  'role_mismatch',
  'license_required',
  'availability_conflict',
  'booking_conflict',
  'existing_booking',
  'unavailable',
  'organization_mismatch',
  'practice_blocked',
]);
export const shiftEligibilityView = z.discriminatedUnion('eligible', [
  z.object({ eligible: z.literal(true) }),
  z.object({ eligible: z.literal(false), reason: z.string(), code: shiftEligibilityCode }),
]);
export type ShiftEligibilityView = z.infer<typeof shiftEligibilityView>;
